export const ProxySymbol: unique symbol = Symbol('proxy');
export const createProxy = <T extends object>(target: T, handler: ProxyHandler<T>): T => {
   return new Proxy<T>(target, {
      ...handler,
      get: (obj, key, receiver) => {
         if (key === ProxySymbol) {
            return obj;
         }

         if (handler.get) {
            return handler.get(obj, key, receiver);
         }

         return Reflect.get(obj, key, receiver);
      },
      has: (obj, key) => {
         if (key === ProxySymbol) {
            return true;
         }
         return Reflect.has(obj, key);
      },
   });
};
